function getTransitionEnd() {
  const transitions = {
    transition: 'transitionend',
    OTransition: 'otransitionend',
    MozTransition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
  };

  for (const t in transitions) {
    if (document.body.style[t] !== undefined) {
      return transitions[t];
    }
  }
}

const supportedEvents = {
  pointerDown: ['pointerdown', 'touchstart', 'mousedown'],
  pointerUp: ['pointerup', 'touchend', 'mouseup'],
  pointerMove: ['pointermove', 'touchmove', 'mousemove'],
  pointerLeave: ['pointerleave', 'touchcancel', 'mouseleave'],
  keyDown: ['keydown'],
  close: ['close'],
  click: ['click'],
};

const getSupportedEvent = eventArray =>
  eventArray.find(eventName => `on${eventName}` in window);

export const POINTER_DOWN = getSupportedEvent(supportedEvents.pointerDown);
export const POINTER_UP = getSupportedEvent(supportedEvents.pointerUp);
// outside event is specific to pixi sprites
export const POINTER_UP_OUTSIDE = POINTER_UP + 'outside';
export const POINTER_MOVE = getSupportedEvent(supportedEvents.pointerMove);
export const POINTER_LEAVE = getSupportedEvent(supportedEvents.pointerLeave);
export const KEY_DOWN = getSupportedEvent(supportedEvents.keyDown);
export const CLOSE = getSupportedEvent(supportedEvents.close);
export const CLICK = getSupportedEvent(supportedEvents.click);
export const TRANSITION_END = getTransitionEnd();

export const POINTER_SUPPORT = 'onpointermove' in window;
export const TOUCH_SUPPORT = 'ontouchmove' in window;
export const MOUSE_SUPPORT = 'onmousedown' in window;
